import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout1 from "./components/Layout";
import Scroll2Top from "./utils/Scroll2Top";
import AdminHome1 from "./views/AdminHome";
import EmployerCreate from "./views/EmployerCreate";
import Employers from "./views/Employers";
import EmployersCenter from "./views/EmployersCenter";
import Home from "./views/Home";
import JobCreate from "./views/JobCreate";
import JobEdit from "./views/JobEdit";
import JobsCenter from "./views/JobsCenter";
import NotAuthorized from "./views/NotAuthorized";
import Login from "./views/auth/Login";
import PersistLogin from "./views/auth/PersistLogin";
import ProtectedRoute from './views/protectedRoute';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Scroll2Top>
        <Routes>
          <Route path="/not-authorized" element={<NotAuthorized />} />
          <Route exact path="/" index element={<Home />} />
          <Route exact path="/home/" element={<Home />} />
          <Route exact path="/Login" element={<Login />} />
          <Route element={<PersistLogin />}>
            <Route exact path="/" element={<Layout1 />}>
              <Route
                exact
                path="/employers/"
                element={
                  <ProtectedRoute
                    element={Employers}
                    allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                  />
                }
              />
              <Route exact path="/jobs/edit/:id?/"
                element={
                  <ProtectedRoute
                    element={JobEdit}
                    allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                  />
                } />

              <Route exact path="/admin-home/" element={<AdminHome1 />} />

              <Route exact path="/create-employer/"
                element={
                  <ProtectedRoute
                    element={EmployerCreate}
                    allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                  />
                } />
              <Route exact path="/employers-center/:id?"
                element={
                  <ProtectedRoute
                    element={EmployersCenter}
                    allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                  />
                } />
              <Route exact path="/jobs-center/"
                element={
                  <ProtectedRoute
                    element={JobsCenter}
                    allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                  />
                } />
              <Route exact path="/post-a-job/" element={
                <ProtectedRoute
                  element={JobCreate}
                  allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                />
              } />
              <Route path="/post-a-job/:postFor?" element={
                <ProtectedRoute
                  element={JobCreate}
                  allowedUserTypes={['Manager', 'Sales', 'employee']} // Specify allowed user types
                />
              } />
            </Route>
          </Route>
        </Routes>
      </Scroll2Top>
    </BrowserRouter>
  );
};
export default AppRouter;
